// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IDki","placeholdersHeader":"styles_placeholdersHeader__211vg","editorStyle":"styles_editorStyle__1tqFr","placeholdersBox":"styles_placeholdersBox__1MNVK"};